<!-- =========================================================================================
  File Name: ECommerceItemDetail.vue
  Description: eCommerce Item Detail page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="item-detail-page">
    <vs-alert
      color="danger"
      title="Error Fetching Product Data"
      :active.sync="error_occured"
    >
      <span>{{ error_msg }}. </span>
      <span>
        <span>Check </span
        ><router-link
          :to="{ name: '/page/health-hacks' }"
          class="text-inherit underline"
          >All Items</router-link
        >
      </span>
    </vs-alert>
    <div></div>
    <vx-card v-if="item_data" :key="item_data.id">
      <template slot="no-body">
        <div class="item-content">
          <!-- Item Main Info -->
          <div class="product-details p-6">
            <div class="vx-row action-icons">
              <add-edit-new-post
                button_type="edit_data_icon"
                :edit_post_data="item_data"
                :categories="category_arr"
                @reload_post_data="fetch_item_details(
                          $route.params.category,
                          $route.params.item_id
                        )"
              />
              <feather-icon
                icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click.stop="deleteItemData(item_data)"
              />
            </div>
            <div class="vx-row mt-6">
              <div
                class="vx-col md:w-2/5 w-full flex items-center justify-center"
              >
                <div class="product-img-container w-3/5 mx-auto mb-10 md:mb-0">
                  <img
                    v-if="item_data.video_url"
                    :src="getYouTubeThumbnail(item_data.video_url)"
                    :alt="item_data.category"
                    class="responsive"
                  />
                  <img
                    v-else
                    src="@/assets/images/logo/DHP Logo no text.png"
                    class="grid-view-img px-4"
                  />
                  <!--
                    UnComment Below line for true flow
                    <img :src="item_data.image" :alt="item_data.name" class="responsive">

                    Remove above img tag which is for demo purpose in actual flow
                  -->
                </div>
              </div>

              <!-- Item Content -->
              <div class="vx-col md:w-3/5 w-full">
                <h3>{{ item_data.video_title }}</h3>

                <p class="my-2 p-3 category-p">
                  <span>{{ item_data.category }}</span>
                </p>

                <p class="p-3">{{ item_data.video_url }}</p>

                <!-- Color -->

                <!-- /Color -->

                <vs-divider />
              </div>
            </div>
          </div>

          <!-- Product Feature/Meta Row -->
          <div class="mb-16 mt-10 text-center item-features">
            <div class="vx-row">
              <div class="vx-col w-full">
                <p class="text-center q-label">Questions</p>
                <div class="flex flex-wrap items-center text-center mb-4">
                  <div
                    class="bg-primary p-3 items-center justify-center text-white cursor-pointer"
                  >
                    <div @click="playQuiz">
                      <feather-icon icon="PlayIcon" svgClasses="h-4 w-4" />
                      <span class="text-sm font-semibold ml-2">Play Quiz</span>
                    </div>
                  </div>

                  <!-- <vs-button
                    icon-pack="feather"
                    icon="icon-play"
                    type="filled"
                    class="play-quiz"
                    @click="playQuiz"
                  >
                    Play Quiz
                  </vs-button> -->
                  <div class="add-question-container">
                    <add-new-questions
                      :item="item_data"
                      v-on:reload_question_data="
                        fetch_item_details(
                          $route.params.category,
                          $route.params.item_id
                        )
                      "
                    />
                  </div>
                </div>
              </div>
            </div>
            <vs-table
              ref="table"
              multiple
              v-model="selected"
              pagination
              :max-items="itemsPerPage"
              :data="item_data.questions"
            >
              <template slot-scope="{ data }">
                <tbody v-if="item_data.questions">
                  <vs-tr
                    :data="tr"
                    :key="indextr"
                    v-for="(tr, indextr) in item_data.questions"
                  >
                    <vs-td>
                      <p class="product-name text-left font-medium truncate">
                        {{ tr.question }}
                      </p>
                    </vs-td>
                    <vs-td>
                      <div
                        class="ml-1 h-3 w-3 rounded-full mr-4"
                        :class="'border-2 border-solid border-warning'"
                      />
                      <!-- <span class="text-lg">{{ tr.type }}</span> -->
                    </vs-td>
                    <vs-td>
                      <span class="text-md">{{ tr.type }}</span></vs-td
                    >
                    <vs-td class="whitespace-no-wrap">
                      <feather-icon
                        icon="EditIcon"
                        svgClasses="w-5 h-5 hover:text-primary stroke-current"
                        @click.stop="editData(tr)"
                      />
                      <feather-icon
                        icon="TrashIcon"
                        svgClasses="w-5 h-5 hover:text-danger stroke-current"
                        class="ml-2"
                        @click.stop="deleteData(tr, indextr)"
                      />
                    </vs-td>
                  </vs-tr>
                </tbody>
              </template>
            </vs-table>
          </div>
        </div>
      </template>
    </vx-card>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.min.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import algoliasearch from "algoliasearch/lite";
import StarRating from "vue-star-rating";
import DataProvider from "../../../services/data-provider";
import Utilities from "../../../services/utilities";
import AddNewQuestions from "../../apps/health-hacks/AddQuestions.vue";
import AddEditNewPost from "../../apps/health-hacks/AddEditNewPost.vue";
import { bus } from "../../../main";
import Constant from "../../../services/constant";
export default {
  components: {
    swiper,
    swiperSlide,
    StarRating,
    AddNewQuestions,
    AddEditNewPost,
  },
  mounted() {
    //  EventBus.$on("reload_question_data", () => {
    //       console.log("reload_question_data");
    //       this.fetch_item_details(this.item_data.id)
    //  })
  },
  data() {
    return {
      category_arr:[],
      algolia_index: algoliasearch(
        "latency",
        "6be0576ff61c053d5f9a3225e2a90f76"
      ).initIndex("instant_search"),
      item_data: "",
      error_occured: false,
      error_msg: "",
      itemsPerPage: 4,
      selected: [],
      // Related Products Swiper
      swiperOption: {
        slidesPerView: 5,
        spaceBetween: 55,
        breakpoints: {
          1600: {
            slidesPerView: 4,
            spaceBetween: 55,
          },
          1300: {
            slidesPerView: 3,
            spaceBetween: 55,
          },
          900: {
            slidesPerView: 2,
            spaceBetween: 55,
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 55,
          },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },

      // Below is data which is common in any item
      // Algolia's dataSet don't provide this kind of data. So, here's dummy data for demo
      available_item_colors: [
        "#7367F0",
        "#28C76F",
        "#EA5455",
        "#FF9F43",
        "#1E1E1E",
      ],
      opt_color: "#7367F0",
      is_hearted: false,
    };
  },
  computed: {
    item_qty() {
      const item = this.$store.getters["eCommerce/getCartItem"](
        this.item_data.id
      );
      return Object.keys(item).length ? item.quantity : 1;
    },
    getItems() {
      console.log(
        "this.$store.getters.healthHacksData;",
        this.$store.getters.healthHacksData
      );
      this.$store.getters.healthHacksData;
    },
    itemColor() {
      return (obj) => {
        const style_obj = {};

        obj.style.forEach((p) => {
          style_obj[p] = obj.color;
        });

        return style_obj;
      };
    },
    isInWishList() {
      return (itemId) => this.$store.getters["eCommerce/isInWishList"](itemId);
    },
    isInCart() {
      return (itemId) => this.$store.getters["eCommerce/isInCart"](itemId);
    },
  },
  methods: {
    editData(data) {
      console.log(data);
      bus.$emit(
        "edit_question",
        data,
        this.item_data.questions,
        this.item_data
      );
    },
      getYouTubeThumbnail(url){
      const id=DataProvider.getYouTubeId(url)
      console.log(id)
      return Constant.you_tube_thumbnail_url+id+Constant.image_type
    },
    playQuiz() {
      this.$router
        .push({
          name: "page-health-hacks-quiz",
          params: {
            category: this.$route.params.category,
            item_id: this.$route.params.item_id,
          },
        })
        .catch(() => {});
    },
    editItemData(data) {
      console.log(data);
      bus.$emit("edit_item_data", data);
    },
    deleteItemData(data) {
      console.log(data);
      let category_name = data.category.split(" ").join("_");
      Utilities.confirmaionDialog(
        "Are you sure?",
        "You won't be able to revert this!",
        "Yes, delete it!"
      ).then((result) => {
        if (result.value) {
          this.$vs.loading();
          DataProvider.deleteDataToCloudFunction(
            data.id,
            "/health_hacks_item/",
            category_name
          ).then(
            (data) => {
              console.log("res", data);
              this.$vs.loading.close();
              this.$router.push("/pages/health-hacks/all");
              Utilities.confirmDialog(
                "Deleted!",
                "Your item has been deleted.",
                "success"
              );
            },
            (err) => {
              DataProvider.sendSentryErrorLog(err)
              this.$vs.loading.close();
              if (err.message.includes("403")) {
                this.$vs.notify({
                  color: "warning",
                  title: "Access denied!",
                });
              }
            }
          );
        }
      });
    },
    deleteData(data, index) {
      console.log(this.item_data);
      let category_name = this.item_data.category.split(" ").join("_");
      console.log(category_name);

      Utilities.confirmaionDialog(
        "Are you sure?",
        "You won't be able to revert this!",
        "Yes, delete it!"
      ).then((result) => {
        if (result.value) {
          DataProvider.deleteDataToCloud(
            this.item_data.id,
            "/health_hacks_question/",
            data.id,
            data,
            category_name
          ).then(
            (data) => {
              console.log("res", data);
              Utilities.confirmDialog(
                "Deleted!",
                "Your item has been deleted.",
                "success"
              );
              console.log(this.item_data);

              this.fetch_item_details(
                this.$route.params.category,
                this.item_data.id
              );
            },
            (err) => {
              DataProvider.sendSentryErrorLog(err)
              if (err.message.includes("403")) {
                this.$vs.notify({
                  color: "warning",
                  title: "Access denied!",
                });
              }
            }
          );
        }
      });
    },
    toggleItemInWishList(item) {
      this.$store.dispatch("eCommerce/toggleItemInWishList", item);
    },
    toggleItemInCart(item) {
      this.$store.dispatch("eCommerce/toggleItemInCart", item);
    },
    fetch_item_details(category_name, id) {
      this.$vs.loading();
      console.log(this.item_data);
      this.all_categories = [];
      DataProvider.getDataFromCloud("/health_hacks_categories").then((data) => {
        if (data.data) {
          this.category_arr = data.data;
        }
      },err=>{
        console.log('err',err)
      });
      category_name = category_name.split(" ").join("_");
      DataProvider.getDetailDataFromCloud(
        "/health_hacks_item_detail/",
        id,
        category_name
      ).then((data) => {
        this.$vs.loading.close();
        console.log("item-details:", data);
        if (data.data) this.item_data = data.data;
      },err=>{
        this.$vs.loading.close();
      });
      //   this.algolia_index.getObject(id, (err, content) => {
      //     if (err) {
      //       this.error_occured = true;
      //       this.error_msg = err.message;
      //       console.error(err);
      //     } else {
      //       console.log(content);
      //       this.item_data = content;
      //     }
      //   });
    },
  },
  created() {
    console.log("created ()");
    this.fetch_item_details(
      this.$route.params.category,
      this.$route.params.item_id
    );
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/_variables.scss";
.swal2-styled.swal2-confirm {
  margin: 5px;
}
#item-detail-page {
  .vs-con-table .vs-con-tbody .con-vs-checkbox {
    justify-content: start !important;
  }
  .color-radio {
    height: 2.28rem;
    width: 2.28rem;

    > div {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .item-features {
    background-color: #f7f7f7;

    .theme-dark & {
      background-color: $theme-dark-secondary-bg;
    }
  }

  .product-sales-meta-list {
    .vs-list--icon {
      padding-left: 0;
    }
  }

  .related-product-swiper {
    // padding-right: 2rem;
    // padding-left: 2rem;

    .swiper-wrapper {
      padding-bottom: 2rem;

      > .swiper-slide {
        background-color: #f7f7f7;
        box-shadow: 0 4px 18px 0 rgba(0, 0, 0, 0.1),
          0 5px 12px 0 rgba(0, 0, 0, 0.08) !important;

        .theme-dark & {
          background-color: $theme-light-dark-bg;
        }
      }
    }

    .swiper-button-next,
    .swiper-button-prev {
      transform: scale(0.5);
      filter: hue-rotate(40deg);
    }

    .swiper-button-next {
      right: 0;
    }

    .swiper-button-prev {
      left: 0;
    }
  }

  p.my-2 span {
    padding: 8px 20px 9px 20px;
    background-color: #ee5d31;
    color: #fff;
    border-radius: 18px;
  }
  .category-p{
    span{
    text-transform: capitalize;
    }
  }
  .add-question-container {
    position: absolute;
    right: 0;
  }
  .q-label {
    font-size: 22px;
  }
  .vx-row.action-icons {
    float: right;
  }
  .vx-row.action-icons .feather-icon {
    cursor: pointer;
  }
}
</style>
